<!-- 横向手势拖动组件 -->
<template>
  <div :id="`scroll-wrapper_${index}`" class="scroll-wrapper">
    <div :id="`scroll-container_${index}`" class="scroll-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      wrapper: null,
      container: null,
    };
  },
  mounted() {
    const wrapper = document.getElementById(`scroll-wrapper_${this.index}`);
    const container = document.getElementById(`scroll-container_${this.index}`);
    let isDown = false;
    let startX;
    let scrollLeft;

    // 鼠标按下事件
    container.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      wrapper.style.cursor = "grabbing";
    });

    // 鼠标离开/松开事件
    ["mouseup", "mouseleave"].forEach((type) => {
      container.addEventListener(type, () => {
        isDown = false;
        wrapper.style.cursor = "grab";
      });
    });

    // 鼠标移动事件
    container.addEventListener("mousemove", (e) => {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1; // 滚动速度系数
      container.scrollLeft = scrollLeft - walk;
      this.$emit("handleScrolling");
    });

    // 禁用默认拖动行为
    container.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });

    this.wrapper = wrapper;
    this.container = container;
  },
  methods: {
    handleMove(left) {
      this.container.scrollTo({
        left,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.scroll-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
  cursor: grab;
  user-select: none;
}

.scroll-container {
  overflow-x: auto;
  display: flex;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
  padding-bottom: 20px;
  /* 隐藏滚动条的空间 */
  margin-bottom: -20px;
  /* 抵消padding */
}

.scroll-container::-webkit-scrollbar {
  display: none;
  /* Chrome/Safari */
}

/* 禁用文字选择 */
.scroll-container * {
  -webkit-user-drag: none;
  user-select: none;
}
</style>
